import { FC, PropsWithChildren } from "react";
import styles from "./Layout.module.scss";
import { Header } from "../Header";
import { Container } from "../../common/Container";
import { Social } from "../Social";
import { Footer } from "../Footer";

interface LayoutProps extends PropsWithChildren {
  classess?: string;
}

const Layout: FC<LayoutProps> = ({ children }) => {
  return (
    <div className={styles.Layout}>
      <Container>
        {
          <>
            <Header />
            <div className={styles.content}>{children}</div>
            <Footer />
          </>
        }
      </Container>
      <Social />
    </div>
  );
};

export default Layout;
